import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "text-large font-600 mr-3" }, /*#__PURE__*/_toDisplayString(`分类审批配置`), -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "text-sm mr-2",
  style: {"margin-left":"10px","font-size":"14px","color":"var(--el-text-color-regular)"}
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("刷新")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("添加配置")
const _hoisted_5 = { style: {"margin-top":"20px"} }
const _hoisted_6 = { style: {"display":"flex","justify-content":"center","align-items":"center"} }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("修改")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "el-dropdown-link vo-ft-pry" }, "更多", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("部门/职位")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("删除")

import { reactive, ref, unref, nextTick, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { CategoryCfgPagedApi, DeletionApi } from '../../../apis/ct_categorys_config/categorycfg.api';
import { GetCategoryApi } from '@/apis/ct_categorys/category.api';
import { TableColumn } from '../../../components/GbTables/GbTablesTypes';
import { CategoryCfgItem, CategoryCfgSearch } from '../../../apis/ct_categorys_config/categorycfg.dto';
import { GbTables } from '@/components/GbTables';
import { useDictionary } from '@/store/dictionary.store';
import { useGbTable } from '../../../hooks/useGbTable';
import moment from 'moment';
import ConfigWriter from './CatConfiguresWriter.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { go } = useRouter();
const { query } = useRoute();
const { getName } = useDictionary();

const search = reactive<CategoryCfgSearch>({
	page_size: 10,
	current: 1,
	category_id: '',
});

/* GbTable 配置 */
const { register, tableObject, methods } = useGbTable<CategoryCfgItem>({
	getListApi: CategoryCfgPagedApi,
	delListApi: DeletionApi,
	response: { data: 'data', total: 'total' },
});

const { setSearchParams } = methods;

/* 数据Table绑定设置 */
const tabColumns = reactive<TableColumn[]>([
	{ field: 'mainstay_name', label: '适用主体', columnWidth: '200' },
	{ field: 'rule_name', label: '规则名称', columnWidth: '250' },
	{ field: 'node_id', label: '审批节点', columnWidth: '100', align: 'center' },
	{ field: 'amt_range', label: '金额区间', columnWidth: '100', align: 'right' },
	{ field: 'remark', label: '备注' },
	{ field: 'is_enabled', label: '启用', columnWidth: '80', align: 'center' },
	{ field: 'created_time', label: '创建日期', columnWidth: '120', fixed: 'right' },
	{ field: 'action', width: '120px', label: '操作', fixed: 'right', align: 'center' },
]);

const writerRef = ref<InstanceType<typeof ConfigWriter>>();
// const deptRelRef = ref<InstanceType<typeof DeptPostsList>>()

const pMethods = {
	/* 打开编辑器 */
	creation: () => {
		const categoryId = query.cagegory_id as string;
		unref(writerRef)?.create(categoryId);
	},

	/* 修改配置 */
	modify: (row: any) => {
		unref(writerRef)?.modify(row.id);
	},

	/* 刷新数据 */
	refresh: () => {
		unref(search).current = 1;
		unref(search).page_size = 10;
		setSearchParams(search);
	},

	/* 删除配置 */
	delete: async (row: any) => {
		await methods.deleteRows({ id: row.id, revision: row.revision });
	},

	/* 部门/职位关联 */
	deptPostRel: (row: any) => {
		// unref(deptRelRef)?.showDialog(row.id)
	},
};

onMounted(async () => {
	const catId = query.cagegory_id as string;
	unref(search).category_id = catId;

	// await getCategoryDetail(catId)
	setSearchParams(search);
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_page_header = _resolveComponent("el-page-header")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, { shadow: "never" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_page_header, {
        onBack: _cache[4] || (_cache[4] = ($event: any) => (_unref(go)(-1)))
      }, {
        content: _withCtx(() => [
          _hoisted_1,
          _hoisted_2
        ]),
        extra: _withCtx(() => [
          _createVNode(_component_el_button, {
            type: "info",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(setSearchParams)(_unref(search))))
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (pMethods.creation()))
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_unref(GbTables), {
              pageSize: _unref(tableObject).pageSize,
              "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((_unref(tableObject).pageSize) = $event)),
              currentPage: _unref(tableObject).currentPage,
              "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => ((_unref(tableObject).currentPage) = $event)),
              columns: _unref(tabColumns),
              data: _unref(tableObject).tableList,
              loading: _unref(tableObject).loading,
              pagination: { total: _unref(tableObject).total },
              onRegister: _unref(register)
            }, {
              node_id: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(_unref(getName)('OA_199', row.node_id)), 1)
              ]),
              created_time: _withCtx(({ row }) => [
                _createElementVNode("span", null, _toDisplayString(_unref(moment)(row.created_time).format('YYYY-MM-DD HH:mm')), 1)
              ]),
              specify_names: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(row.specify_names || '未指定'), 1)
              ]),
              condition: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(_unref(getName)('condition', row.condition)), 1)
              ]),
              is_enabled: _withCtx(({ row }) => [
                _createVNode(_component_el_tag, {
                  size: "small",
                  type: row.is_enabled == 'Y' ? 'success' : 'danger'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(row.is_enabled == 'Y' ? '启用' : '停用'), 1)
                  ]),
                  _: 2
                }, 1032, ["type"])
              ]),
              action: _withCtx(({ row }) => [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_el_button, {
                    type: "success",
                    link: "",
                    onClick: ($event: any) => (pMethods.modify(row))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_el_dropdown, {
                    style: {"padding":"2px","margin-left":"12px"},
                    trigger: "click"
                  }, {
                    dropdown: _withCtx(() => [
                      _createVNode(_component_el_dropdown_menu, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_dropdown_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                type: "info",
                                link: "",
                                onClick: ($event: any) => (pMethods.deptPostRel(row))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_9
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_dropdown_item, { divided: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                type: "danger",
                                link: "",
                                onClick: ($event: any) => (pMethods.delete(row))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_10
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 2
                  }, 1024)
                ])
              ]),
              _: 1
            }, 8, ["pageSize", "currentPage", "columns", "data", "loading", "pagination", "onRegister"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})